// Mirrors the backend com.sm.spectum.models.enums.Ability names verbatim.
export const ABILITIES = {
  VIEW_MATERIALS: "VIEW_MATERIALS",
  VIEW_PURCHASE_REQUESTS: "VIEW_PURCHASE_REQUESTS",
  VIEW_ORDERS: "VIEW_ORDERS",
  VIEW_DELIVERIES: "VIEW_DELIVERIES",
  VIEW_SUPPLIERS: "VIEW_SUPPLIERS",
  VIEW_USERS: "VIEW_USERS",
  VIEW_TAGS: "VIEW_TAGS",
  VIEW_SITES: "VIEW_SITES",
  VIEW_ANALYTICS: "VIEW_ANALYTICS",
  VIEW_CHAT: "VIEW_CHAT",
  MANAGE_USERS: "MANAGE_USERS",
  ADMINISTER_USERS: "ADMINISTER_USERS",
  MANAGE_ROLES: "MANAGE_ROLES",
  MANAGE_GROUPS: "MANAGE_GROUPS",
  CREATE_MATERIALS: "CREATE_MATERIALS",
  EDIT_MATERIALS: "EDIT_MATERIALS",
  CREATE_PURCHASE_REQUESTS: "CREATE_PURCHASE_REQUESTS",
  APPROVE_REQUESTS: "APPROVE_REQUESTS",
  CREATE_ORDERS: "CREATE_ORDERS",
  AWARD_ORDERS: "AWARD_ORDERS",
  MANAGE_SUPPLIERS: "MANAGE_SUPPLIERS",
  MANAGE_DELIVERIES: "MANAGE_DELIVERIES",
  MANAGE_SITES: "MANAGE_SITES",
  MANAGE_TAGS: "MANAGE_TAGS",
  SELLER_VIEW_OPPORTUNITIES: "SELLER_VIEW_OPPORTUNITIES",
  SELLER_SUBMIT_OFFERS: "SELLER_SUBMIT_OFFERS",
  SELLER_VIEW_BIDDINGS: "SELLER_VIEW_BIDDINGS",
  SELLER_VIEW_COMPANY: "SELLER_VIEW_COMPANY",
  SELLER_MANAGE_COMPANY: "SELLER_MANAGE_COMPANY",
  SELLER_VIEW_DELIVERIES: "SELLER_VIEW_DELIVERIES",
  SELLER_MANAGE_DELIVERIES: "SELLER_MANAGE_DELIVERIES",
  SELLER_VIEW_USERS: "SELLER_VIEW_USERS",
  SELLER_MANAGE_USERS: "SELLER_MANAGE_USERS",
  SELLER_ADMINISTER_USERS: "SELLER_ADMINISTER_USERS",
  SELLER_VIEW_CHAT: "SELLER_VIEW_CHAT",
  SELLER_MANAGE_ROLES: "SELLER_MANAGE_ROLES",
  VIEW_PURCHASE_ORDERS: "VIEW_PURCHASE_ORDERS",
  CREATE_PURCHASE_ORDERS: "CREATE_PURCHASE_ORDERS",
  APPROVE_PURCHASE_ORDERS: "APPROVE_PURCHASE_ORDERS",
  MANAGE_PURCHASE_ORDER_APPROVALS: "MANAGE_PURCHASE_ORDER_APPROVALS",
  SELLER_RESPOND_PURCHASE_ORDERS: "SELLER_RESPOND_PURCHASE_ORDERS",
} as const;

export type Ability = (typeof ABILITIES)[keyof typeof ABILITIES];
